import {
  Add,
  Remove,
  VerifiedUser,
  Contacts,
  SupervisedUserCircle,
  PostAdd,
  AllInbox,
  Work
} from '@material-ui/icons';

export const Data = [
  // {
  //   menu: 'Home',
  //   icon: HomeOutlined,
  //   url: '/home',
  // },
  {
    menu: 'Job Portal',
    icon: Work,
    url: '/positions',
    submenu: [
      {
        title: 'Positions',
        icon: PostAdd,
        url: '/positions',
        group: 'positions'
      },
      {
        title: 'Applicants',
        icon: AllInbox,
        url: '/applicants',
        group: 'applicants'
      },
    ],
  },
  {
    id: 3,
    menu: 'Admin',
    icon: VerifiedUser,
    submenu: [
      {
        title: 'Clients',
        icon: Contacts,
        url: '/clients',
        group: 'clients'
      },
      {
        title: 'User Management',
        icon: SupervisedUserCircle,
        url: '/users',
        group: 'users'
      },
    ],
  },
];

export const AccordionIcon = {
  plusIcon: Add,
  minusIcon: Remove,
};
